// extracted by mini-css-extract-plugin
export var root = "super-hero-module--root--4Y68r";